<template>
    <div class="">
        <header-portrate />
        <exports-print ref="exportbar" />
        <TabsComp :tabs="tabs" />
        <div class="p-3" :style="`direction:${lang.dir}`">
            <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="m-0">{{ lang.purchase_requests || lang.spare_parts_requests || lang.request_spare_parts || 'Spare Parts Requests' }}</h5>
            <div>
                <b-button size="sm" variant="primary" @click="loadRequests">{{ lang.refresh || 'Refresh' }}</b-button>
            </div>
            </div>

            <v-simple-table>
            <thead>
                <tr>
                <th class="text-center backBlack">{{ lang.cardid || 'Job Card #' }}</th>
                <th class="text-center backBlack">{{ lang.worker_name || 'Requested By' }}</th>
                <th class="text-center backBlack">{{ lang.status || 'Status' }}</th>
                <th class="text-center backBlack">{{ lang.availability || 'Availability' }}</th>
                <th class="text-center backBlack">{{ lang.action || 'Action' }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in requests" :key="index">
                <td class="text-center">{{ row.job_card_number || row.job_card_id }}</td>
                <td class="text-center">{{ row.requested_by_name || '-' }}</td>
                <td class="text-center">{{ row.status }}</td>
                <td class="text-center">
                    <span v-if="row.inventory_status === 'available'" style="color:green;font-weight:bold;">In-Stock</span>
                    <span v-else-if="row.inventory_status === 'out_of_stock'" style="color:red;font-weight:bold;">Out of Stock</span>
                    <span v-else>Manual Review Required</span>
                </td>
                <td class="text-center">
                    <b-button size="sm" class="mr-1" variant="success" @click="updateStatus(row, 'approved')">Approve</b-button>
                    <b-button size="sm" class="mr-1" variant="danger" @click="updateStatus(row, 'rejected')">Reject</b-button>
                    <b-button size="sm" variant="warning" @click="createPurchaseBill(row)">Create Purchase Bill</b-button>
                </td>
                </tr>
                <tr v-if="!requests.length">
                <td class="text-center" colspan="5">{{ lang.no_data || 'No data' }}</td>
                </tr>
            </tbody>
            </v-simple-table>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import TabsComp from '@/components/tabsComp.vue'
export default {
  components: {
    HeaderPortrate,
    Footer,
    TabsComp,
  },
  data() {
    return {
      requests: [],
      timerId: null,
    }
  },
  computed: {
    lang() {
      if (this.$cookies.get(this.$store.state.LangCooki) != null) {
        if (this.$cookies.get(this.$store.state.LangCooki) == 'en') return this.$store.state.lang.en;
        if (this.$cookies.get(this.$store.state.LangCooki) == 'ur') return this.$store.state.lang.ur;
        return this.$store.state.lang.ar;
      }
      if (this.$store.state.deflang == 'en') return this.$store.state.lang.en;
      if (this.$store.state.deflang == 'ur') return this.$store.state.lang.ur;
      return this.$store.state.lang.ar;
    },
    tabs: function() {
        const menu = this.$store.getters['state'].menu;

            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            // console.log("menu",this.$store.getters['state'].licenseType)
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
    }
  },
  created() {
    this.loadRequests();
    this.timerId = setInterval(() => {
      this.loadRequests();
    }, 30000);
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  methods: {
    async postApi(type, payload = {}) {
      const post = new FormData();
      post.append('defBranch', localStorage.getItem('defBranch') || '1');
      post.append('financeYear', localStorage.getItem('financeYear') || '');
      post.append('type', type);
      post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
      Object.keys(payload).forEach((key) => {
        post.append(`data[${key}]`, payload[key]);
      });

      const response = await fetch(this.$store.state.SAMCOTEC.r_path, {
        method: 'POST',
        body: post,
      });
      return response.json();
    },
    async loadRequests() {
      const res = await this.postApi('get_requests_list', {
        lang: this.$cookies.get(this.$store.state.LangCooki),
      });
      if (res && res.error && res.error.number === 200) {
        this.requests = (res.results && res.results.data) ? res.results.data : [];
      }
    },
    async updateStatus(row, status) {
      if (!row || !row.id) return;
      if (status === 'approved') {
        const confirmText = this.lang.confirm_approve_spare_request || 'Are you sure you want to approve this spare parts request?';
        if (!window.confirm(confirmText)) return;
      }
      if (status === 'rejected') {
        const confirmText = this.lang.confirm_decline_spare_request || this.lang.confirm_delete || 'Are you sure you want to reject this request?';
        if (!window.confirm(confirmText)) return;
      }
      await this.postApi('update_request_status', {
        request_id: row.id,
        status,
        note: `Updated from PurchaseRequests view to ${status}`,
      });
      await this.loadRequests();
    },
    async createPurchaseBill(row) {
      if (!row || !row.id) return;
      const confirmText = this.lang.confirm_create_purchase_bill || 'Are you sure you want to create purchase bill / mark as ordered?';
      if (!window.confirm(confirmText)) return;
      const manual = window.prompt('Enter purchase bill id (optional). Leave empty to mark ordered without link.', '');
      await this.postApi('update_request_status', {
        request_id: row.id,
        status: 'ordered',
        purchase_bill_id: manual ? Number(manual) : 0,
        note: 'Create purchase bill action',
      });
      await this.loadRequests();
    },
  },
}
</script>
